/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeletePvdConfigRequest
 */
export interface DeletePvdConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof DeletePvdConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof DeletePvdConfigRequest
     */
    config_id: string;
}

/**
 * Check if a given object implements the DeletePvdConfigRequest interface.
 */
export function instanceOfDeletePvdConfigRequest(value: object): value is DeletePvdConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('config_id' in value) || value['config_id'] === undefined) return false;
    return true;
}

export function DeletePvdConfigRequestFromJSON(json: any): DeletePvdConfigRequest {
    return DeletePvdConfigRequestFromJSONTyped(json, false);
}

export function DeletePvdConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletePvdConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'config_id': json['config_id'],
    };
}

export function DeletePvdConfigRequestToJSON(json: any): DeletePvdConfigRequest {
    return DeletePvdConfigRequestToJSONTyped(json, false);
}

export function DeletePvdConfigRequestToJSONTyped(value?: DeletePvdConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'config_id': value['config_id'],
    };
}

